import React from 'react';
import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import CommonSocials from "@/components/common/Socials";
import Stages from "@/components/Menu/Mobile/Stages";
import IPayButton from "@/components/common/Buttons/IPayButton";
import CommonLocaleSelect from "@/components/common/LocaleSelect";
import {DROPDOWN_VARIANTS} from "@/components/common/Dropdown";


const Socials = styled(CommonSocials)`
	padding-left: var(--paddingX);
`
const LocaleSelect = styled(CommonLocaleSelect)`
	margin-left: auto;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    --padding-y: ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.richBlack};
    padding: var(--padding-y) var(--paddingX);
	overflow-y: auto;
`

const Button = styled(IPayButton)`
	margin-top: ${getCssSizeValue(26, BREAKPOINTS.MOBILE)};
	margin-left: var(--paddingX);
`

const MobileMenu = ({ items = [], ...props}) => {
	// console.log(items);

	return (
		<Container >
			<Stages data={items}/>
			<Button/>
			<Socials  color="periwinkle">
				<LocaleSelect short variant={DROPDOWN_VARIANTS.MOBILE} dropUp />
			</Socials>
		</Container>
	);
};

export default MobileMenu;
